'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseStringAsDom = parseStringAsDom;
/**
 * @summary Parses an HTML String into DOM Objects
 * @description
 * This method takes an HTML String and returns the correct DOM Object structure for it.
 * The returned Object will always be a `HTMLCollection` containing all of the root nodes,
 * even if there is only a single root node.
 *
 * The root nodes will be attached to a temporary wrapper that is not part of the page tree.
 * As such, the wrapper can be ignored.
 *
 * @example
 * import { parseStringAsDom } from '@nimius/dom-utility'
 *
 * const dom = parseStringAsDom(`
 *      <ul class="cool">
 *          <li>This</li>
 *          <li>is</li>
 *          <li>pretty</li>
 *          <li>cool</li>
 *      </ul>
 * `);
 * // => HTMLCollection
 *
 * const list = dom[0]
 * // => HTMLUListElement
 *
 * document.body.appendChild(list);
 *
 * @param {string} string - The HTML that should be parsed
 * @returns {HTMLCollection} - Collection of all root elements of the parsed DOM.
 */
function parseStringAsDom(string) {
  var wrapper = document.createElement('div');
  wrapper.innerHTML = string;
  return wrapper.children;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/dom-utility/src/parse-string-as-dom.js
// module id = 106
// module chunks = 0 2